/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Search_CountriesInputs */



/**
* | output |
* | --- |
* | "Search countries..." |
*
* @param {Community_Search_CountriesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_search_countries = /** @type {((inputs?: Community_Search_CountriesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Search_CountriesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher des pays...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar países...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pesquisar países...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca paesi...")
	return /** @type {LocalizedString} */ ("Search countries...")
});